import React from 'react';
import { styled } from '../../../../libs/styled.es.js';

const StyledToast = styled.div `
  font-size: 12px;
  transition: 0.1s ease-out;
  overflow: hidden;
  display: flex;
  align-items: center;
  padding: 6px 16px;
  height: auto;
  background-color: rgba(36, 36, 36, 0.9);
  color: white;
  outline: 0;
  border-radius: 20px;
  white-space: nowrap;
`;
const StyledWrapper = styled.div `
  background-color: #30cd60;
  box-shadow: 5px 5px 20px 1px rgba(0, 0, 0, 0.1);
  padding: 0.3rem 0.7rem;
  border-radius: 1rem;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: max-content;
`;
const Message = styled.p `
  color: white;
  font-size: 13px;
  font-weight: 400;
  line-height: 24px;
  margin-bottom: 0;
`;
const Icon = styled.div `
  border-radius: 50%;
  width: 1.125rem;
  height: 1.125rem;
  background-color: white;
  position: relative;
  margin-right: 0.3rem;

  &::after {
    width: 5px;
    height: 8px;
    border: 2px solid #30cd60;
    content: ' ';
    transform: rotate(45deg) translate(-50%, -50%);
    transform-origin: top left;
    position: absolute;
    top: 50%;
    left: 50%;
    border-top: 0;
    border-left: 0;
  }
`;
const InfoToast = ({ message, variant = 'info', }) => {
    return variant === 'success' ? (React.createElement(StyledWrapper, null,
        React.createElement(Icon, null),
        React.createElement(Message, null, message))) : (React.createElement(StyledToast, null, message));
};

export { InfoToast };
